import { useIntl } from "react-intl";
import moment from "moment";
import { calculateTimeBetweenDates, formatDuration } from "../../helpers/ShipmentQuotesV2Helpers";

interface QuotationScheduleProps {
  quotation: any;
}

export default function QuotationSchedule({ quotation }: QuotationScheduleProps) {
  const intl = useIntl();
  const { schedule, service } = quotation || {};
  const { quoted_pickup_date, quoted_time_delivery_date, flights } = schedule;

  const serviceRequirement = service?.service_confirmation_data?.find((item: any) =>
    ["DTD", "DTP", "PTP", "PTD"].includes(item.service_type),
  )?.service_type;

  const transitCount = flights?.length;

  const data = [
    {
      label: intl.formatMessage({
        id: "general.pickup",
        defaultMessage: "Pickup",
      }),
      content: (
        <>
          {moment(quoted_pickup_date).format("DD MMM YYYY")},{" "}
          <span className="font-regular">{moment(quoted_pickup_date).format("HH:mm")}</span>
        </>
      ),
    },
    {
      label: intl.formatMessage({
        id: "general.delivery",
        defaultMessage: "Delivery",
      }),
      content: (
        <>
          {moment(quoted_time_delivery_date).format("DD MMM YYYY")},{" "}
          <span className="font-regular">{moment(quoted_time_delivery_date).format("HH:mm")}</span>
        </>
      ),
    },
    {
      label: intl.formatMessage({
        id: "general.transit",
        defaultMessage: "Transit",
      }),
      content: (
        <>
          {formatDuration(calculateTimeBetweenDates(quoted_pickup_date, quoted_time_delivery_date))}
          {serviceRequirement && <span> • </span>}
          {serviceRequirement && <span className="font-regular">{serviceRequirement}</span>}
          {transitCount > 0 && (
            <span className="font-regular">
              {transitCount === 1 ? (
                <>
                  ,{" "}
                  {intl.formatMessage({
                    id: "general.direct",
                    defaultMessage: "Direct",
                  })}
                </>
              ) : (
                <>
                  , {transitCount} {intl.formatMessage({ id: "general.stops", defaultMessage: "Stops" })}
                </>
              )}
            </span>
          )}
        </>
      ),
    },
  ];

  return (
    <div className="d-flex gap-lg">
      {data.map((item, index) => (
        <div key={index} className="bg-secondary radius-sm py-md px-lg flex-1">
          <div className="text-xs text-secondary-v2 font-medium">{item.label}</div>
          <div className="text-sm text-primary font-medium">{item.content}</div>
        </div>
      ))}
    </div>
  );
}
